export const TIMEFRAME_QUARTER_IDS = [1, 2, 3, 4];
